import { FilterOptionsEnum } from "../../../../../utils/enrollmentRulesUtils";
import { getDropdownOptions } from "../../../../../utils/dropdownUtils";

export interface MsGraphRule {
  filter?: number | null;
  type: number | null;
  value: any;
}

export enum TypeOptionsEnum {
  JobTitle = 1,
  Department,
  CreatedDate,
  Country,
  OfficeLocation,
  HiredDate,
  Manager,
  License,
  Group,
  CompanyName,
}

export type MsGraphFilterOptionsMap = {
  [key in TypeOptionsEnum]?: { text: string; value: string }[];
};

export enum RuleCombineType {
  And = 1,
  Or,
}

export const ruleCombineTypeOptions = [
  {
    value: RuleCombineType.And,
    text: "And",
  },
  {
    value: RuleCombineType.Or,
    text: "Or",
  },
];
export const defaultRule: MsGraphRule = { filter: null, type: null, value: "" };

export const ruleOptions = [
  {
    value: TypeOptionsEnum.Department,
    text: "Department",
  },
  {
    value: TypeOptionsEnum.JobTitle,
    text: "Job Title",
  },
  {
    value: TypeOptionsEnum.Country,
    text: "Country",
  },
  {
    value: TypeOptionsEnum.OfficeLocation,
    text: "Office Location",
  },
  {
    value: TypeOptionsEnum.Manager,
    text: "Reports To",
  },
  {
    value: TypeOptionsEnum.CreatedDate,
    text: "Created Date",
  },
  {
    value: TypeOptionsEnum.HiredDate,
    text: "Hired Date",
  },
  {
    value: TypeOptionsEnum.CompanyName,
    text: "Company Name",
  },
  {
    value: TypeOptionsEnum.License,
    text: "License Type",
  },
  {
    value: TypeOptionsEnum.Group,
    text: "Group",
  },
];

const strictTextFilterOptions = [
  {
    value: FilterOptionsEnum.IsEqualTo,
    text: "Is Equal To",
  },
  {
    value: FilterOptionsEnum.IsNotEqualTo,
    text: "Is Not Equal To",
  },
];

const textFiltersOptions = [
  ...strictTextFilterOptions,
  {
    value: FilterOptionsEnum.Contains,
    text: "Contains",
  },
  {
    value: FilterOptionsEnum.DoesNotContain,
    text: "Does Not Contain",
  },
];

const dateFiltersOptions = [
  {
    value: FilterOptionsEnum.IsBetween,
    text: "Is Between",
  },
  {
    value: FilterOptionsEnum.IsNotBetween,
    text: "Is Not Between",
  },
  {
    value: FilterOptionsEnum.IsOnOrAfter,
    text: "Is On Or After",
  },
  {
    value: FilterOptionsEnum.IsOnOrBefore,
    text: "Is On Or Before",
  },
];

export const columnTitles = [
  {
    title: "Rule",
    fieldName: "type",
    info: "Select a rule that will trigger a users automatic enrollment",
    width: 18,
  },
  { title: "Filter", fieldName: "filter", info: "Choose a filter to further narrow criteria", width: 16 },
  {
    title: "Criteria",
    fieldName: "value",
    info: "Select a specific criteria for the rule that will trigger a users automatic enrollment",
    width: 25,
  },
];

export const getFilterOptions = (type: number) => {
  switch (type) {
    case TypeOptionsEnum.Department:
    case TypeOptionsEnum.JobTitle:
    case TypeOptionsEnum.Country:
    case TypeOptionsEnum.OfficeLocation:
    case TypeOptionsEnum.Manager:
    case TypeOptionsEnum.CompanyName:
      return textFiltersOptions;
    case TypeOptionsEnum.License:
    case TypeOptionsEnum.Group:
      return strictTextFilterOptions;
    case TypeOptionsEnum.CreatedDate:
    case TypeOptionsEnum.HiredDate:
      return dateFiltersOptions;
    default:
      return null;
  }
};

export const getCriteriaOptions = (type: TypeOptionsEnum, value: string, options: MsGraphFilterOptionsMap) => {
  if (!options[type]) return null;

  return getDropdownOptions(value, options[type]);
};
